import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import Logo from "../../assets/images/Bodybon-Logo.png";
import bodybonQrcode from "../../assets/images/bodybon-qr-code.png";

const styles = StyleSheet.create({
  container: {
    height: "100%",
    padding: 50,
    backgroundColor: "#29ABE2",
  },
  pdfIntro: {
    height: "100%",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  pdfIntroLogo: {
    width: 100,
    height: 100,
    borderWidth: 10,
    marginBottom: 20,
    borderRadius: 500,
    borderColor: "#29ABE2",
    backgroundColor: "#29ABE2",
  },
  pdfIntroContent: {
    height: "100%",
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  pdfIntroTitleWrapper: {
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "center",
  },
  pdfIntroTitle: {
    fontSize: 45,
    fontWeight: 900,
    marginBottom: 2,
    color: "#fff",
    textAlign: "center",
    fontFamily: "rokh",
  },
  pdfIntroSubTitle: {
    fontSize: 26,
    color: "#fff",
    textAlign: "center",
    fontFamily: "rokh",
    fontWeight: 700,
  },
  pdfIntroFooterWrapper: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  pdfIntroAddress: {
    fontSize: 22,
    marginTop: 8,
    textAlign: "center",
    color: "#fff",
    fontFamily: "rokh",
  },
  pdfIntroQrcodeWrapper: {
    width: 90,
    height: 120,
    padding: 8,
    borderRadius: 10,
    backgroundColor: "#fff",
  },
  pdfIntroQrcode: {
    width: "100%",
    height: "100%",
  },
});

const PdfIntro = () => {
  return (
    <View style={styles.container}>
      <View style={styles.pdfIntro}>
        <View style={styles.pdfIntroContent}>
          <Image style={styles.pdfIntroLogo} src={Logo} />
          <View style={styles.pdfIntroTitleWrapper}>
            <Text style={styles.pdfIntroTitle}>بادی</Text>
            <Text style={styles.pdfIntroTitle}>بان</Text>
          </View>
          <Text style={styles.pdfIntroSubTitle}>
            پلتفرم تفسیر آزمایش با هوش مصنوعی
          </Text>
          <Text style={styles.pdfIntroSubTitle}>
            !خواندن جواب
            <Text style={styles.pdfIntroSubTitle}>آزمایش‌های</Text>
            پزشکیت رو به ما بسپر
          </Text>
        </View>
        <View style={styles.pdfIntroFooterWrapper}>
          <View style={styles.pdfIntroQrcodeWrapper}>
            <Image src={bodybonQrcode} style={styles.pdfIntroQrcode} />
          </View>
          <Text style={styles.pdfIntroAddress}>www.bodybon.info</Text>
        </View>
      </View>
    </View>
  );
};

export default PdfIntro;
